<template>
  <div class="Read">
    <div class="read-content">
      <div class="content-nav">
        <div class="nav">
          <div class="nav-title">
            <img src="../../../assets/img/reader/time.png" alt="" />
            <span>阅读历史</span>
          </div>
        </div>
        <el-collapse>
          <el-collapse-item>
            <template slot="title">
              <i class="el-icon-caret-right" style="padding-right: 10px"></i>
              全部
            </template>
            <p @click="ChangText = 1" :class="{ cur: ChangText === 1 }">
              一周记录
            </p>
            <p @click="ChangText = 2" :class="{ cur: ChangText === 2 }">
              三月记录
            </p>
            <p @click="ChangText = 3" :class="{ cur: ChangText === 3 }">
              所有记录
            </p>
          </el-collapse-item>
        </el-collapse>
      </div>
      <div class="read-list">
        <ul>
          <li v-show="ChangText===1"><Hebdomad /></li>
          <li v-show="ChangText===2"><March /></li>
          <li v-if="ChangText===3"><Entire /></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { listReadHistory } from "@/utils/router/reader.api";
import Hebdomad from './Hebdomad.vue'
import March from './March.vue'
import Entire from './Entire.vue'
export default {
  data() {
    return {
      ChangText: 3,
      historyList: [],
      Show: false,
    };
  },
  components: {
    March,
    Entire,
    Hebdomad
  },
  created() {
    listReadHistory({
      userId: this.$store.state.userInfo.userId,
      typeId: this.$store.state.typeId,
      timeType: 0,
    }).then((res) => {
      this.historyList = res.data.data || []
      if(this.historyList = []) {
        this.Show = true
      }
    });
  },
};
</script>

<style lang="less" scoped>
.Read {
  margin-bottom: 56px;
  .read-content {
    min-height: 600px;
    border: 1px solid #dcdcdc;
    box-shadow: 0px 4px 7px 0px rgba(6, 0, 1, 0.1);
    display: flex;
    padding: 12px 32px;
    .content-nav {
      width: 248px;
      border-right: 2px solid #654719;
      padding-right: 32px;
      .nav-title {
        border-bottom: 2px solid #654719;
        color: #654719;
        font-size: 24px;
        font-weight: bold;
        line-height: 108px;
        img {
          width: 28px;
          height: 28px;
          position: relative;
          top: 4px;
          margin-right: 14px;
          margin-left: 18px;
        }
      }
      /deep/.el-collapse-item__header {
        height: 72px;
        font-size: 20px;
        font-weight: bold;
        padding-left: 22px;
      }
      /deep/.el-collapse-item__header.is-active {
        background-color: #efece8;
        color: #654719;
      }
      /deep/.el-collapse-item__content {
        padding-bottom: 0;
        p {
          font-size: 20px;
          font-weight: bold;
          cursor: pointer;
          line-height: 66px;
          padding-left: 52px;
        }
      }
      /deep/.el-collapse-item__arrow {
        display: none;
      }
      .cur {
        background-color: #efece8;
        color: #654719;
        cursor: pointer;
        margin-top: 2px;
      }
    }
    .read-list {
      margin-left: 34px;
      .list {
        flex: 1;
        height: 286px;
        display: flex;
        .list-one,.list-two {
          width: 400px;
          display: flex;
          .left {
            width: 124px;
            border-right: 2px solid #f0e9df;
            padding-right: 10px;
            img {
              width: 119px;
            }
            .el-button {
              width: 114px;
              height: 30px;
              font-size: 14px;
              margin-top: 20px;
              line-height: 13px;
            }
            .book-status {
              color: #d68c0a;
              font-size: 20px;
              margin-top: 30px;
              margin-left: 15px;
              letter-spacing: 2px;
            }
          }
          .right {
            flex: 1;
            padding-left: 12px;
            .book-name {
              height: 80px;
              color: #343434;
              font-size: 20px;
              line-height: 40px;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
            }
            ul {
              li {
                display: flex;
                font-size: 18px;
                letter-spacing: 2px;
                line-height: 50px;
              }
              li p:first-child {
                color: #797979;
              }
              li p:last-child {
                width: 190px;
                color: #404040;
                padding-left: 40px;
                overflow: hidden;
                text-overflow:ellipsis;
                white-space: nowrap;
              }
            }
          }
        }
        .list-two {
          margin-left: 60px;
        }
      }
    }
  }
}
.empty {
  position: relative;
  left: 332px;
  top: 30px;
}
</style>
